// Theme: hologram
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'hologram',
  name: 'HOLOGRAM',
  tagline: 'HOLOGRAM',
  description: 'Ciano holografico com profundidade diagonal e reflexo tridimensional.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#050F18', '#00E5FF', '#0A1F35', '#B3FFFE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-mono theme-hologram'
  },
  colorVars: {
    '--accent': '#00E5FF',
    '--accent-foreground': '#050F18',
    '--background': '#050F18',
    '--border': '#0A5A8F',
    '--card': '#0A1F35',
    '--card-border-active': 'rgba(0, 229, 255, 0.48)',
    '--card-completed': '#0A1F35',
    '--card-foreground': '#B3FFFE',
    '--card-glow': 'rgba(0, 229, 255, 0.1)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#050F18',
    '--foreground': '#B3FFFE',
    '--hold-fill': '#00E5FF',
    '--input': '#0A1F35',
    '--modal-bg': '#050F18',
    '--modal-border': '#0A5A8F',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#0A5A8F',
    '--muted-foreground': '#B3FFFE',
    '--nav-active': '#00E5FF',
    '--nav-bg': '#050F18',
    '--popover': '#0A1F35',
    '--popover-foreground': '#B3FFFE',
    '--primary': '#00E5FF',
    '--primary-foreground': '#050F18',
    '--ring': '#00E5FF',
    '--secondary': '#0A5A8F',
    '--secondary-foreground': '#B3FFFE',
    '--streak': '#00E5FF',
    '--success': '#22C55E',
    '--success-foreground': '#050F18',
    '--xp': '#00E5FF',
    '--xp-bg': '#0A1F35'
  },
  resolvedVars: {
    '--accent': '#00E5FF',
    '--accent-foreground': '#050F18',
    '--accent-foreground-hsl': '208 66% 6%',
    '--accent-foreground-oklch': 'from #050F18 l c h',
    '--accent-hsl': '186 100% 50%',
    '--accent-oklch': 'from #00E5FF l c h',
    '--background': '#050F18',
    '--background-hsl': '208 66% 6%',
    '--background-oklch': 'from #050F18 l c h',
    '--border': '#0A5A8F',
    '--border-hsl': '204 87% 30%',
    '--border-oklch': 'from #0A5A8F l c h',
    '--border-w': '1px',
    '--card': '#0A1F35',
    '--card-border-active': 'rgba(0, 229, 255, 0.48)',
    '--card-completed': '#0A1F35',
    '--card-completed-hsl': '211 68% 12%',
    '--card-completed-oklch': 'from #0A1F35 l c h',
    '--card-foreground': '#B3FFFE',
    '--card-foreground-hsl': '179 100% 85%',
    '--card-foreground-oklch': 'from #B3FFFE l c h',
    '--card-glow': 'rgba(0, 229, 255, 0.1)',
    '--card-hsl': '211 68% 12%',
    '--card-oklch': 'from #0A1F35 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#050F18',
    '--destructive-foreground-hsl': '208 66% 6%',
    '--destructive-foreground-oklch': 'from #050F18 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#B3FFFE',
    '--foreground-hsl': '179 100% 85%',
    '--foreground-oklch': 'from #B3FFFE l c h',
    '--hold-fill': '#00E5FF',
    '--hold-fill-hsl': '186 100% 50%',
    '--hold-fill-oklch': 'from #00E5FF l c h',
    '--input': '#0A1F35',
    '--input-hsl': '211 68% 12%',
    '--input-oklch': 'from #0A1F35 l c h',
    '--modal-bg': '#050F18',
    '--modal-bg-hsl': '208 66% 6%',
    '--modal-bg-oklch': 'from #050F18 l c h',
    '--modal-border': '#0A5A8F',
    '--modal-border-hsl': '204 87% 30%',
    '--modal-border-oklch': 'from #0A5A8F l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#0A5A8F',
    '--muted-foreground': '#B3FFFE',
    '--muted-foreground-hsl': '179 100% 85%',
    '--muted-foreground-oklch': 'from #B3FFFE l c h',
    '--muted-hsl': '204 87% 30%',
    '--muted-oklch': 'from #0A5A8F l c h',
    '--nav-active': '#00E5FF',
    '--nav-active-hsl': '186 100% 50%',
    '--nav-active-oklch': 'from #00E5FF l c h',
    '--nav-bg': '#050F18',
    '--nav-bg-hsl': '208 66% 6%',
    '--nav-bg-oklch': 'from #050F18 l c h',
    '--popover': '#0A1F35',
    '--popover-foreground': '#B3FFFE',
    '--popover-foreground-hsl': '179 100% 85%',
    '--popover-foreground-oklch': 'from #B3FFFE l c h',
    '--popover-hsl': '211 68% 12%',
    '--popover-oklch': 'from #0A1F35 l c h',
    '--primary': '#00E5FF',
    '--primary-foreground': '#050F18',
    '--primary-foreground-hsl': '208 66% 6%',
    '--primary-foreground-oklch': 'from #050F18 l c h',
    '--primary-hsl': '186 100% 50%',
    '--primary-oklch': 'from #00E5FF l c h',
    '--radius': '12px',
    '--ring': '#00E5FF',
    '--ring-hsl': '186 100% 50%',
    '--ring-oklch': 'from #00E5FF l c h',
    '--secondary': '#0A5A8F',
    '--secondary-foreground': '#B3FFFE',
    '--secondary-foreground-hsl': '179 100% 85%',
    '--secondary-foreground-oklch': 'from #B3FFFE l c h',
    '--secondary-hsl': '204 87% 30%',
    '--secondary-oklch': 'from #0A5A8F l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#00E5FF',
    '--streak-hsl': '186 100% 50%',
    '--streak-oklch': 'from #00E5FF l c h',
    '--success': '#22C55E',
    '--success-foreground': '#050F18',
    '--success-foreground-hsl': '208 66% 6%',
    '--success-foreground-oklch': 'from #050F18 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(186 100% 50% / 0.15)',
    '--xp': '#00E5FF',
    '--xp-bg': '#0A1F35',
    '--xp-bg-hsl': '211 68% 12%',
    '--xp-bg-oklch': 'from #0A1F35 l c h',
    '--xp-hsl': '186 100% 50%',
    '--xp-oklch': 'from #00E5FF l c h'
  }
}
